import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons/faCircleExclamation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from 'antd';
import { t } from 'i18next';

export const confirmBlockedSlotDelete = (onOkCallback: () => void) => {
  const { confirm } = Modal;

  confirm({
    title: t('scheduling.blockedSlot.deleteBlockedSlotConfirm'),
    icon: <FontAwesomeIcon icon={faCircleExclamation} />,
    okButtonProps: {
      danger: true,
    },
    cancelButtonProps: {
      type: 'text',
    },
    onOk() {
      onOkCallback();
    },
    centered: true,
    closable: true,
  });
};

export const unsavedChangesModal = (onOkCallback: () => void) => {
  const { confirm } = Modal;

  confirm({
    title: t('common.confirmCancel.unsavedChanges'),
    icon: <FontAwesomeIcon icon={faCircleExclamation} />,
    okText: t('common.buttons.confirm'),
    cancelText: t('common.buttons.cancel'),
    cancelButtonProps: {
      type: 'text',
    },
    onOk() {
      onOkCallback();
    },
    closable: true,
  });
};
